import { motion } from "framer-motion";
import { Check, Crown, Sparkles } from "lucide-react";

const REVV_CARD = "https://static.prod-images.emergentagent.com/jobs/0529fec7-0ce1-4229-bf36-7b88d48e13e7/images/977fdb814449d22ea9e7770ffcd1a24dd82fa24a1f8048a715dadfe6a887011b.png";

const benefits = [
  "Exclusive discounts on Biker Boulevard merchandise",
  "Riding gear & apparel discounts",
  "Priority access to premium motorcycles",
  "Members-only riding events",
  "Partner brand discounts",
  "Fuel & café partner benefits",
  "Special discount when buying from us & additional bonus amount when selling to us",
  "Touring community access",
];

export default function RevvPass() {
  return (
    <section id="revvpass" data-testid="revvpass-section" className="relative py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at center, rgba(0,204,204,0.08), transparent 60%), #0D0F12" }} />
      <div className="absolute inset-0 grid-bg opacity-10" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto"
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#00cccc]/30 bg-[#00cccc]/5 mb-6">
            <Crown className="w-3.5 h-3.5 text-[#00cccc]" />
            <span className="text-xs tracking-[0.25em] uppercase text-[#00cccc] font-mono">RevvPass — Rider Elite</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight">
            Unlock the <span className="text-gradient-cyan">Rider Elite.</span>
          </h2>
          <p className="mt-5 text-zinc-400 text-lg">
            Join RevvPass and access exclusive rewards, rider privileges, premium experiences, and member-only benefits.
          </p>
        </motion.div>

        <div className="mt-16 grid lg:grid-cols-12 gap-10 items-center">
          {/* Card visual */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5 flex justify-center"
          >
            <motion.div
              animate={{ y: [0, -14, 0], rotate: [-2, 2, -2] }}
              transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
              className="relative"
            >
              <div className="absolute inset-0 blur-3xl bg-[#00cccc]/20 rounded-full scale-90" />
              <img src={REVV_CARD} alt="RevvPass Membership Card" className="relative w-[340px] md:w-[420px] rounded-2xl" style={{ filter: "drop-shadow(0 20px 60px rgba(0,204,204,0.3))" }} />
            </motion.div>
          </motion.div>

          {/* Benefits & pricing */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <div className="grid sm:grid-cols-2 gap-2.5">
              {benefits.map((b, i) => (
                <motion.div
                  key={b}
                  initial={{ opacity: 0, x: 10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: i * 0.03 }}
                  className="flex items-start gap-2.5"
                >
                  <Check className="w-4 h-4 text-[#00cccc] mt-0.5 shrink-0" />
                  <span className="text-sm text-zinc-300">{b}</span>
                </motion.div>
              ))}
            </div>

            {/* Launching Soon */}
            <div className="mt-10">
              <div
                className="relative p-8 rounded-2xl glass-cyan neon-glow overflow-hidden"
                data-testid="revvpass-launching-soon"
              >
                <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00cccc] to-transparent" />
                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-[#00cccc]/10 border border-[#00cccc]/40 shrink-0">
                    <Sparkles className="w-5 h-5 text-[#00cccc]" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#00cccc] animate-pulse-glow" />
                      <span className="text-[10px] font-mono tracking-[0.3em] uppercase text-[#00cccc]">Launching Soon</span>
                    </div>
                    <h3 className="mt-3 text-2xl sm:text-3xl font-bold text-white leading-tight">
                      RevvPass is gearing up.
                    </h3>
                    <p className="mt-2 text-sm text-zinc-400 max-w-lg leading-relaxed">
                      We're putting the final polish on India's most exclusive rider membership. Drop your email below to get early access and founding member perks.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
